import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginLayoutComponent } from '@app/root/components/login-layout/login-layout.component';
import { PassFormComponent } from '@app/root/components/pass-form/pass-form.component';
import { AuthApiService } from '@services/auth-api.service';
import Utils from '@shared/providers/utils';
import { SharedModule } from '@shared/shared.module';
import { injectQueryParams } from 'ngxtension/inject-query-params';

@Component({
  selector: 'app-pass-reset',
  imports: [FormsModule, SharedModule, LoginLayoutComponent, PassFormComponent],
  templateUrl: './pass-reset.component.html',
})
export class PassResetComponent {
  readonly authApiService = inject(AuthApiService);
  readonly destroyRef = inject(DestroyRef);
  readonly router = inject(Router);

  token = injectQueryParams('token');
  error = signal('');
  isSending = signal(false);

  onSend(password: string) {
    this.error.set('');
    this.isSending.set(true);
    this.authApiService
      .resetPassword(this.token() ?? 'NONE', password)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.router.navigate(['/login'], { queryParams: { success: 'reset' } });
          this.isSending.set(false);
        },
        error: (err: HttpErrorResponse) => {
          this.error.set(Utils.formatHttpError(err));
          this.isSending.set(false);
        },
      });
  }
}
